import * as Events from './Events';
import * as helper from './../../../../../VX/View/Assets/Js/helper';
import SignupBackend from './../../../Assets/Js/SignupBackend';

export default class Selector {
	constructor(mainElement) {
		this.mainElement = mainElement;
		this.step1 = helper.$('#step1');
		this.step2 = helper.$('#step2');
		this.step3 = helper.$('#step3');

		this.sexSelectors = [helper.$('#FrauSelector'), helper.$('#MannSelector')];
		this.signupHelper = new SignupBackend();
		this.checkSignup = true;

		this._addEventListener();
	}

	_addEventListener() {
		const yesNo = [helper.$('#JaSelector'), helper.$('#NeinSelector')];
		const form = helper.$('#register');

		for (let image of this.sexSelectors) {
			helper.addEventListener(image, 'click', (evt) => {
				helper.removeClass(this.sexSelectors[0], 'selected');
				helper.removeClass(this.sexSelectors[1], 'selected');
				helper.addClass(evt.currentTarget, 'selected');
				helper.hide(this.step1);
				helper.show(this.step2);
				helper.triggerEvent(window, Events.DIV_SWITCHED);
			});
		}

		for (let button of yesNo) {
			helper.addEventListener(button, 'click', (evt) => {
				evt.preventDefault();
				helper.hide(this.step2);
				helper.show(this.step3);
				helper.hide(document.getElementById('count'));
				helper.triggerEvent(window, Events.DIV_SWITCHED);
			});
		}

		helper.addEventListener(form, 'submit', (evt) => {
			if (this.checkSignup) {
				evt.preventDefault();

				this.signupHelper.checkSignup(form.querySelector('#username').value, form.querySelector('#email').value)
					.then((response) => {
						if (response.data.success === false) {
							if (typeof response.data.messages.username !== 'undefined') {
								alert(response.data.messages.username.join(', '));
								return null;
							}
							if (typeof response.data.messages.email !== 'undefined') {
								alert(response.data.messages.email.join(', '));
								return null;
							}
						} else {
							this.checkSignup = false;
							form.submit();
						}
					});
			}
		});
	}
}
